export default __webpack_public_path__ + "static/media/logo-bdstrading.f5b58157.svg";